// Deposit output order (IMPLEMENTATION §0.2 R1): first acceptors round-robin, N/E/S/W from the deposit's
// rotating start `rr`; then empty floor round-robin from the same start (a floor tile a chute chain is
// delivering onto is not empty: topology freeUnreserved). The chosen direction's successor becomes the next
// start. Pure: the caller commits `rr` and the spawn.

import { DIRS, opposite, stepCell } from '../core/grid.ts';
import type { Dir, Int } from '../core/types.ts';
import type { Ctx } from '../ctx.ts';
import { buildingAt } from '../entities.ts';
import type { FamId } from '../gen/ids.ts';
import type { DepositB } from '../state.ts';
import { freeUnreserved } from '../topology.ts';
import { acceptsFromDeposit } from './accept.ts';

export type DepositOutput =
  | { k: 'accept'; bid: Int; dirIdx: Int }
  | { k: 'floor'; x: Int; y: Int; dirIdx: Int };

export function depositOutput(c: Ctx, dep: DepositB, fam: FamId, tier: Int): DepositOutput | null {
  for (let i = 0; i < 4; i++) {
    const di = (dep.rr + i) % 4;
    const dir = DIRS[di] as Dir;
    const n = stepCell(dep.x, dep.y, dir);
    const b = buildingAt(c, n.x, n.y);
    if (b !== null && acceptsFromDeposit(c, b, fam, tier, opposite(dir))) {
      return { k: 'accept', bid: b.id, dirIdx: di };
    }
  }
  for (let i = 0; i < 4; i++) {
    const di = (dep.rr + i) % 4;
    const n = stepCell(dep.x, dep.y, DIRS[di] as Dir);
    if (freeUnreserved(c, n.x, n.y)) return { k: 'floor', x: n.x, y: n.y, dirIdx: di };
  }
  return null;
}
